<template>
    <div v-if="state" class="AlgoliaSearchLocationsDropdown">
        <BaseIcon
            icon="address"
            class="AlgoliaSearchLocationsDropdown__icon text--blue"
        />

        <multiselect
            :value="selected"
            :options="groupedItems"
            group-values="towns"
            group-label="region"
            placeholder="Locations"
            track-by="value"
            label="label"
            :multiple="false"
            select-label=""
            deselect-label=""
            select-group-label=""
            deselect-group-label=""
            selected-label=""
            @select="refine($event.value)"
        >
            <template v-slot:caret>
                <BaseIcon
                    icon="chevron-down-icon"
                    class="AlgoliaSearchLocationsDropdown__chevron text--blue"
                />
            </template>

            <template v-slot:noResult>
                <span>No results found.</span>
            </template>
        </multiselect>

        <BaseIcon
            v-if="selected.length !== 0"
            @click.native="clearRefinements"
            class="clear-field"
            icon="cross-thick"
        />
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { connectRefinementList } from "instantsearch.js/es/connectors";
import { createWidgetMixin } from "vue-instantsearch";
import { groupBy, map, sortBy, filter } from "lodash";

export default {
    mixins: [createWidgetMixin({ connector: connectRefinementList })],

    components: {
        Multiselect
    },

    props: {
        attribute: {
            type: String,
            required: true
        }
    },

    computed: {
        // Selected town formatted for multiselect
        selected() {
            const towns = filter(this.formattedTowns, ['isRefined', true]);
            return sortBy(towns, 'label');
        },

        // Remove 'Region >' from label for display in multiselect
        formattedTowns() {
            return this.state.items.map((item) => {
                item.label = item.label.split(' > ')[1];
                return item;
            });
        },

        groupedItems() {
            // Sort and groups all towns by region
            const sorted = sortBy(this.formattedTowns, 'value');
            const grouped = groupBy(sorted, (item) => item.value.split(' > ')[0]);

            // Format shape into something multiselect can read
            return map(grouped, (towns, key) => ({
                region: key,
                towns
            }));
        },

        widgetParams() {
            return {
                attribute: this.attribute,
                limit: 1000
            };
        }
    },

    methods: {
        clearRefinements() {
            this.state.refine(this.selected[0].value);
        },

        refine(town) {
            this.$emit('refined');
            if (this.selected.length !== 0) {
                this.state.refine(this.selected[0].value);
            }

            this.state.refine(town);
        }
    }
};
</script>

<style lang="scss">
    .AlgoliaSearchLocationsDropdown {
        position: relative;
        border-bottom: 2px solid getColour('blue') !important;
        flex-grow: 1;

        .multiselect {
            padding: 10px 0 10px 30px !important;
            min-height: 20px;
            box-sizing: inherit !important;
        }

        .multiselect__input, .multiselect__placeholder, .multiselect__single {
            margin: 0;
            padding: 0;
            color: getColour('grey', 'dark');
            font-size: 18px;
            background-color: transparent;
            line-height: normal;

            @include media-query(desk-wide) {
                font-size: 1rem;
            }

            @include media-query(tiny) {
                font-size: 16px;
            }
        }

        .multiselect__tags {
            padding: 0;
            border: none;
            min-height: 20px;
            background-color: transparent;
        }

        .multiselect__option {
            background-color: transparent !important;
            color: getColour('grey', 'dark') !important;

            @include media-query(palm) {
                white-space: unset;
                font-size: 14px;
            }
        }

        .multiselect__option:hover {
            color: #fff !important;
            background-color: getColour('blue') !important;
        }


        .multiselect__option--group {
            font-family: $heading-font-family;
            font-size: 21px;
            text-transform: uppercase;
            font-weight: 800;
            color: #000 !important;

            @include media-query(palm) {
               font-size: 16px;
            }
        }

        .multiselect__content-wrapper {
            left: 0;
            right: 0;
            top: calc(100% + 2px);
        }

        .multiselect--above .multiselect__content-wrapper {
            top: auto;
        }

        .clear-field {
            fill: rgba(60, 60, 60, 0.5) !important;
            width: 10px !important;
            height: 10px !important;
            position: absolute;
            right: 21px;
            top: 50%;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }
        }

        .AlgoliaSearchLocationsDropdown__chevron {
            position: absolute;
            right: 0;
            top: 18px;
        }

        .multiselect__option {
            padding: 12px 30px;

            @include media-query(palm) {
                padding: 12px;
            }
        }

        .multiselect__content {
            padding-top: 15px;

            @include media-query(palm) {
                min-width: unset;
            }
        }

        @include media-query(desk-wide) {
            top: -3px;
        }
    }

    .AlgoliaSearchLocationsDropdown__icon {
        position: absolute;
        top: 8px;
        left: 0;
        font-size: 24px;
    }

</style>
